import { getURLParameterByName } from '../../../shared/utils';


const AuthError = 'AuthError';
const SessionNotAuthorized = 'SessionNotAuthorized';
const SessionExpired = 'SessionExpired';
const SessionInvalidDomain = 'SessionInvalidDomain';


const getAuthMessage = (code: string, value: string) => {
	const map = {
		[`${AuthError}:IAC`]: 'Система запущена в некорректных условиях',
		[`${AuthError}:User login/password is empty`]: 'Введен пустой логин или пароль',
		[`${AuthError}:Security ticket not provided`]: 'Введен неправильный логин или пароль',
		[`${AuthError}:AuthenticationException`]: 'Введен неправильный логин или пароль',
		[SessionNotAuthorized]: 'Сессия пользователя не авторизована системой. Введите имя пользователя и пароль и нажмите Войти',
		[SessionExpired]: `Ваш сеанс работы с системой завершен по причине отсутствия активности в течение${value} мин.`,
		[SessionInvalidDomain]: 'Ошибка авторизации. Сессия пользователя не авторизована для данного домена',
	};
	const key = `${code}:${value}`;
	
	return map[key] || map[code] || 'Ошибка авторизации. Обратитесь в техподдержку';
}

export type AuthResult = {
	status: boolean;
	value: string;
	message: string;
}

function useAuthResult(): [Record<string, AuthResult>] {
	const codes = [
		AuthError,
		SessionExpired,
		SessionNotAuthorized,
		SessionInvalidDomain,
	];
	const authResult = {};

	codes.forEach((code) => {
		if (Boolean(getURLParameterByName(code))) {
			const value = getURLParameterByName(code);
			authResult[code] = {
				status: true,
				value,
				message: getAuthMessage(code, value)
			}
		}
	});

	return [authResult];
}

export {
	useAuthResult
}